import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getAllOrders } from '../../../store/actions/user/User';
import OrderItemCard from '../../Common/OrderItemCard';
import Pagination from '@material-ui/lab/Pagination';
import BackDrop from '../../../components/User/Preloader/BackDrop';

const Orders = ({ getAllOrders, api_progress, orderCount, orders }) => {

    const [orderList, updateOrderList] = useState([]);
    const [pageNo, updatePageNo] = useState(1);

    useEffect(() => {
        getAllOrders(pageNo).then(resp => {
            updateOrderList(resp?.data || []);
        })
    }, []);

    const handlePagination = (e, page) => {
        window.scrollTo(0, 0);
        updatePageNo(page)
        getAllOrders(page).then(resp => {
            updateOrderList(resp?.data || []);
        })
    }

    return (
        <div>
            <BackDrop open={api_progress}></BackDrop>
            {
                orders?.map(item =>
                    <OrderItemCard id={item.id} vendor={item?.vendorDetails[0]} image={item?.vendorDetails[0]?.logo} date={item?.createdAt} items={item?.orderDetails} price={item?.totalPrice} status={item.status} order={item} address={item?.address} />
                )
            }
            <br></br>
            <br></br>
            {orders && orders.length > 0 &&
                <Pagination
                    count={orderCount ? Math.ceil(orderCount / 10) : 1}
                    color="primary"
                    page={pageNo}
                    onChange={handlePagination}
                />
            }
            <br></br>
            <br></br>

        </div>
    );
};

const mapDispatchWithProps = (dispatch) => {
    return {
        getAllOrders: (pageNumber) => dispatch(getAllOrders(pageNumber))
    }
}

const mapStateWithProps = (state) => ({
    api_progress: state.user.api_progress,
    orderCount: state.user.orders?.total_data,
    orders: state.user.orders?.data
});

export default connect(mapStateWithProps, mapDispatchWithProps)(Orders);